export default __webpack_public_path__ + "static/media/moviedex.44296c63.png";